module.exports = "../images/fishing-lodge-15.jpg?v=9e71b69";